'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (val) {
  var replaceWith = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return val === null ? replaceWith : val;
};